const headerNavigationLinks = {
    minimumLinksInMenu: 0,
    $headerNavigationLinks: $('#headerNavigationLinks'),
    $headerNavigationElement: $('#headerNavigationMenu'),
    init() {
        // process this only for desktop view
        if (commonUtils.isMobileView()) {
            return false;
        }
        this.headerLinkWidth = this.$headerNavigationLinks.width();
        this.headerTotalLinks = this.$headerNavigationLinks.children('li:not(:last)').length;
        this.loop = 1;
        this.maximumWidth = $('.fullHeaderSection').width() - ($('.headerRightSection').width() + 34);
        this.manageLinks();

        return undefined;
    },
    reset() {
        this.$headerNavigationLinks.children('li:not(:last)').show();
        $('#headerNavigationMenuList').html('');
        this.minimumLinksInMenu = 0;
        this.$headerNavigationElement.hide();
    },
    manageLinks() {
        if (this.$headerNavigationElement.length > 0 && this.headerLinkWidth > this.maximumWidth) {
            this.$headerNavigationElement.show();
            this.minimumLinksInMenu = 2;
        }

        while (
            this.$headerNavigationElement.length &&
            (this.headerLinkWidth > this.maximumWidth || this.loop <= this.minimumLinksInMenu)
        ) {
            let listItem = this.$headerNavigationLinks.children('li:not(:last)').eq(this.headerTotalLinks - this.loop);
            let linkInsideListItem = $(listItem).find('a');
            $(listItem).hide();
            $('#headerNavigationMenuList').prepend(
                `<a href="${$(linkInsideListItem).prop('href')}" class="" target="${$(linkInsideListItem).prop('target')}">${$(linkInsideListItem).prop('text')}</a>`
            );
            this.loop += 1;
            this.headerLinkWidth = this.$headerNavigationLinks.width(); // reset width

            // In case of any JS error loop goes into infinite loop, to avoid this break after total menu links
            if (this.loop > this.headerTotalLinks) {
                break;
            }
        }
    },
};

headerNavigationLinks.init();

$(window).on('orientationchange resize', function () {
    headerNavigationLinks.reset();
    headerNavigationLinks.init();
});
